var fails = require('../internals/fails');

module.exports = !fails(function () {
  return Object.isExtensible(Object.preventExtensions({}));
});



//////////////////
// WEBPACK FOOTER
// ../sdk/map/node_modules/core-js/internals/freezing.js
// module id = 81
// module chunks = 0